import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center p-3 text-2xl" }
const _hoisted_2 = { class: "flex flex-row gap-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 2 2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0,1 2,2 2,0",
    fill: "currentColor"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 2 2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2,1 0,2 0,0",
    fill: "currentColor"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString($options.frameCounter), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.goToPreviousFrame && $options.goToPreviousFrame(...args))),
        class: "cursor-pointer hover:opacity-50"
      }, _hoisted_4),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.goToNextFrame && $options.goToNextFrame(...args))),
        class: "cursor-pointer hover:opacity-50"
      }, _hoisted_6)
    ])
  ]))
}